var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddTarget(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 31.875C8.7975 31.875 2.125 25.2025 2.125 17C2.125 8.7975 8.7975 2.125 17 2.125C25.2025 2.125 31.875 8.7975 31.875 17C31.875 25.2025 25.2025 31.875 17 31.875ZM17 4.25C9.96625 4.25 4.25 9.96625 4.25 17C4.25 24.0338 9.96625 29.75 17 29.75C24.0338 29.75 29.75 24.0338 29.75 17C29.75 9.96625 24.0338 4.25 17 4.25Z",
    fill: "#00ADEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 24.4375C16.405 24.4375 15.9375 23.97 15.9375 23.375V10.625C15.9375 10.03 16.405 9.5625 17 9.5625C17.595 9.5625 18.0625 10.03 18.0625 10.625V23.375C18.0625 23.97 17.595 24.4375 17 24.4375Z",
    fill: "#00ADEF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.375 18.0625H10.625C10.03 18.0625 9.5625 17.595 9.5625 17C9.5625 16.405 10.03 15.9375 10.625 15.9375H23.375C23.97 15.9375 24.4375 16.405 24.4375 17C24.4375 17.595 23.97 18.0625 23.375 18.0625Z",
    fill: "#00ADEF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTarget);
export default __webpack_public_path__ + "static/media/addTarget.f144c8f51592366e8f183520606493b5.svg";
export { ForwardRef as ReactComponent };